<template>
  <modal
    ref="addReport"
    :ok-disabled="loading"
    :ok-title="!$parent.id ? 'Pridať' : 'Upraviť'"
    :title="!$parent.id ? 'Pridať report' : 'Upraviť report'"
    cancel-title="Zrušiť"
    full-height
    name="add-consumer"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveReport"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" v-bar>
          <div>
            <b-form-group
              label-cols-sm="5"
              label="Obdobie (m/r)"
              label-for="period"
            >
              <single-date
                v-model="form.reportDate"
                v-validate="'required'"
                :format="measureTypeFormat"
                :class="{ 'is-invalid': errors.has('period') }"
                data-vv-as="Obdobie"
                name="period"
              />
              <b-form-invalid-feedback>
                {{ errors.first('period') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Od" label-for="dateFrom">
              <single-date
                v-model="form.dateFrom"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('dateFrom') }"
                data-vv-as="Od"
                name="dateFrom"
              />
              <b-form-invalid-feedback>
                {{ errors.first('dateFrom') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Do" label-for="dateTo">
              <single-date
                v-model="form.dateTo"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('dateTo') }"
                data-vv-as="Do"
                name="dateTo"
              />
              <b-form-invalid-feedback>
                {{ errors.first('dateTo') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Vodné (m3)"
              label-for="water"
            >
              <vue-autonumeric
                v-model="form.water"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('water') }"
                class="form-control"
                data-vv-as="Vodné"
                name="water"
              />
              <b-form-invalid-feedback>
                {{ errors.first('water') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Stočné (m3)"
              label-for="sewerage"
            >
              <vue-autonumeric
                v-model="form.sewerage"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('sewerage') }"
                class="form-control"
                data-vv-as="Stočné"
                name="sewerage"
              />
              <b-form-invalid-feedback>
                {{ errors.first('sewerage') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Zrážky (m3)"
              label-for="rainfall"
            >
              <vue-autonumeric
                v-model="form.rainfall"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('rainfall') }"
                class="form-control"
                data-vv-as="Zrážky"
                name="rainfall"
              />
              <b-form-invalid-feedback>
                {{ errors.first('rainfall') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Celková cena (€ bez dph)"
              label-for="totalPrice"
            >
              <vue-autonumeric
                v-model="form.totalPrice"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('totalPrice') }"
                class="form-control"
                data-vv-as="Celková cena"
                name="totalPrice"
              />
              <b-form-invalid-feedback>
                {{ errors.first('totalPrice') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="Poznámka" label-for="note">
              <b-form-input v-model="form.note" name="note" />
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import SingleDate from '@/components/inputs/SingleDate'
import Modal from '@/components/Modal'
import { mapState } from 'vuex'

export default {
  components: {
    SingleDate,
    Modal,
  },
  data() {
    return {
      loading: false,
      form: {},
      field: [],
      month: null,
      year: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
    measureTypeFormat() {
      return 'MM/YYYY'
    },
  },
  methods: {
    fetchData() {
      this.form.energetics_id = parseInt(this.$route.params.energetics_id)
      if (this.$parent.id) {
        this.loading = true
        this.$api
          .get(`reports/${this.$parent.id}/consumer/get_form`)
          .then((res) => {
            this.form = res.data.data
            this.loading = false
          })
      }
    },
  },
}
</script>
